import { useCart } from './store';

export function useCartCount() {
  return useCart((state) => state.lines.reduce((total, line) => total + line.qty, 0));
}
